import { Injectable } from '@angular/core';
import { SideBarNotification } from '@app/core/models';
import { SideBarNotificationService } from '@app/core/services/side-bar-notification.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { distinctUntilChanged, map, switchMap } from 'rxjs';
import { getSideBarNotificationList, getSideBarNotificationListSuccess } from '../actions/side-bar-notification.actions';

@Injectable()
export class SideBarNotificationEffects {

  constructor(private actions: Actions, private sideBarNotificationService: SideBarNotificationService) { }

  getSideBarNotificationList = createEffect(() => {
    return this.actions.pipe(
      ofType(getSideBarNotificationList),
      distinctUntilChanged(),
      switchMap(() => this.sideBarNotificationService.getNotificationList()),
      map(notificationList => {
        let sideBarNotificationList = [];
        if (notificationList && notificationList.length > 0) notificationList.forEach(i => sideBarNotificationList.push(new SideBarNotification(i)));
        return getSideBarNotificationListSuccess({ payload: sideBarNotificationList });
      })
    )
  });

}
